import { createReducer } from '@reduxjs/toolkit';
import { FinderShape } from './model';
import * as finderActions from './actions';
import * as lastStateActions from '../lastState/actions';
import * as assetLinkActions from '../assetLink/actions';

const initial: FinderShape = {
  selected: {
    ids: [],
    firstId: undefined,
    lastId: undefined,
  },
  containerWidth: 0,
  details: { asset: undefined, error: false },
  detailsLoading: false,
  detailsVisible: true,
  slotHeight: undefined,
  slotDragging: false,
  isOriginalView: false,
};

export const finderReducer = createReducer<FinderShape>(initial, (builder) =>
  builder
    .addCase(finderActions.assetSelected, (s, a) => {
      s.selected = a.payload;
    })
    .addCase(finderActions.detailsChanged, (s, a) => {
      s.details.asset = a.payload.asset;
      s.details.error = a.payload.error;
      s.isOriginalView = false;
    })
    .addCase(finderActions.originalViewEnabled, (s) => {
      s.isOriginalView = true;
    })
    .addCase(finderActions.setDetailsLoading, (s, a) => {
      s.detailsLoading = a.payload.loading;
    })
    .addCase(finderActions.setDetailsVisible, (s, a) => {
      s.detailsVisible = a.payload.visible;
    })
    .addCase(finderActions.containerWidthChanged, (s, a) => {
      s.containerWidth = a.payload.width;
    })
    .addCase(lastStateActions.applied, (s, a) => {
      if (a.payload) {
        const { selected, detailsVisible } = a.payload.state.data.finder;
        s.detailsVisible = detailsVisible;
        s.selected = selected
          ? { ids: selected.ids, firstId: selected.firstId, lastId: selected.lastId } // ts требует явного задания firstId, lastId
          : s.selected;
      } else {
        s.detailsVisible = initial.detailsVisible;
        s.selected = initial.selected;
      }
    })
    .addCase(assetLinkActions.deleted, (s, a) => {
      if (s.details.asset?.id === a.payload.assetId) {
        s.details.asset.links = s.details.asset.links.filter(({ id }) => id !== a.payload.linkId);
      }
    })
    .addCase(assetLinkActions.saved, (s, a) => {
      const { link } = a.payload;
      if (s.details.asset?.id === link.asset_id) {
        const index = s.details.asset.links.findIndex(({ id }) => id === link.id);
        if (index === -1) {
          s.details.asset.links = [link, ...s.details.asset.links];
        } else {
          s.details.asset.links[index] = link;
        }
      }
    })
    .addCase(finderActions.slotHeightChanged, (s, a) => {
      s.slotHeight = a.payload.slotHeight;
    })
    .addCase(finderActions.setSlotDragging, (s, a) => {
      s.slotDragging = a.payload.slotDragging;
    }),
);
